(function () {
  var toggle = document.querySelector("[data-nav-toggle]");
  var panel = document.querySelector("[data-nav-panel]");
  var iconMenu = document.querySelector("[data-icon-menu]");
  var iconClose = document.querySelector("[data-icon-close]");
  if (toggle && panel) {
    toggle.addEventListener("click", function () {
      var open = panel.hasAttribute("hidden");
      if (open) panel.removeAttribute("hidden");
      else panel.setAttribute("hidden", "");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      if (iconMenu) iconMenu.hidden = open;
      if (iconClose) iconClose.hidden = !open;
    });
  }

  var form = document.querySelector("[data-donate-form]");
  if (!form) return;

  var amountInput = form.querySelector("[name='amount']");
  var customWrap = form.querySelector("[data-custom-wrap]");
  var customForm = document.querySelector("[data-custom-request]");
  var checkoutBox = form.querySelector("[data-checkout-fields]");
  var freq = form.querySelector("[name='frequency']");
  var cover = form.querySelector("[name='cover_fee']");
  var totalEl = form.querySelector("[data-total]");
  var submit = form.querySelector("[data-submit-label]");
  var note = form.querySelector("[data-amount-note]");
  var monthlyNote = form.querySelector("[data-monthly-note]");
  var errorEl = form.querySelector("[data-donate-error]");
  var notes = {};
  try {
    notes = JSON.parse(form.getAttribute("data-notes") || "{}");
  } catch (e) {
    notes = {};
  }

  function money(cents) {
    var n = cents / 100;
    var whole = cents % 100 === 0;
    return n.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: whole ? 0 : 2,
    });
  }

  function chip(selector, attr, value, idle) {
    form.querySelectorAll(selector).forEach(function (btn) {
      var on = btn.getAttribute(attr) === value;
      btn.classList.toggle("bg-tape", on);
      btn.classList.toggle("text-bg", on);
      btn.classList.toggle("bg-bg", !on);
      btn.classList.toggle(idle, !on);
      btn.classList.toggle("shadow-border", !on);
    });
  }

  function priceFor(amount) {
    var btn = form.querySelector('[data-amount="' + amount + '"]');
    if (!btn) return 0;
    return parseInt(btn.getAttribute("data-price") || "0", 10);
  }

  function feeFor(amount) {
    var btn = form.querySelector('[data-amount="' + amount + '"]');
    if (!btn) return 0;
    return parseInt(btn.getAttribute("data-fee") || "0", 10);
  }

  function paint() {
    var custom = amountInput.value === "custom";
    chip("[data-amount]", "data-amount", amountInput.value, "text-fg");
    chip("[data-freq]", "data-freq", freq.value, "text-fg-muted");
    if (customWrap) customWrap.hidden = !custom;
    if (customForm) customForm.hidden = !custom;
    if (checkoutBox) checkoutBox.hidden = custom;
    if (note) {
      var n = notes[String(amountInput.value)];
      note.hidden = !n;
      if (n) note.textContent = n;
    }
    if (monthlyNote) monthlyNote.hidden = freq.value !== "monthly";
    var cents = priceFor(amountInput.value);
    var fee = cover && cover.checked ? feeFor(amountInput.value) : 0;
    var charged = cents + fee;
    if (totalEl) {
      totalEl.hidden = !(cover && cover.checked && cents > 0);
      if (cents) totalEl.textContent = "Checkout total " + money(charged);
    }
    if (submit) {
      if (!cents) submit.textContent = "Checkout unavailable";
      else submit.textContent = "Check out " + money(charged);
    }
  }

  form.querySelectorAll("[data-amount]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      amountInput.value = btn.getAttribute("data-amount");
      if (errorEl) errorEl.hidden = true;
      paint();
    });
  });
  form.querySelectorAll("[data-freq]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      freq.value = btn.getAttribute("data-freq");
      paint();
    });
  });
  if (cover) cover.addEventListener("change", paint);

  var deskSelect = form.querySelector("[data-desk-select]");
  if (deskSelect) {
    deskSelect.addEventListener("change", function () {
      var radio = form.querySelector('input[name="designation"][value="country"]');
      if (radio) radio.checked = true;
    });
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    if (errorEl) errorEl.hidden = true;
    if (amountInput.value === "custom") return;

    var amount = amountInput.value;
    var variantId = form.getAttribute("data-variant-" + amount);
    if (!variantId) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = "This amount is not a live product yet. Import the donation CSV in Shopify admin, publish both products, then reload.";
      }
      return;
    }

    var desk = "Where needed most";
    var selected = form.querySelector('input[name="designation"]:checked');
    if (selected && selected.value === "country" && deskSelect) {
      desk = deskSelect.options[deskSelect.selectedIndex].text;
    } else if (selected) {
      var label = selected.closest("label");
      var nameEl = label && label.querySelector("span span");
      desk = nameEl ? nameEl.textContent.trim() : selected.value;
    }

    var name = (form.querySelector("[name='donor_name']") || {}).value || "";
    var email = (form.querySelector("[name='donor_email']") || {}).value || "";
    var dedication = (form.querySelector("[name='dedication']") || {}).value || "";
    var anonymous = form.querySelector("[name='anonymous']") && form.querySelector("[name='anonymous']").checked;
    if (!name.trim() || !email.trim()) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = "Name and email go on the packing slip.";
      }
      return;
    }

    var properties = {
      Desk: desk,
      Cadence: freq.value === "monthly" ? "Monthly intent — this charge is one-time" : "One-time",
      "Name on slip": anonymous ? "Anonymous" : name,
      Email: email,
    };
    if (dedication.trim()) properties.Dedication = dedication.trim();

    var items = [{ id: Number(variantId), quantity: 1, properties: properties }];
    if (cover && cover.checked) {
      var feeId = form.getAttribute("data-fee-" + amount);
      if (feeId) {
        items.push({
          id: Number(feeId),
          quantity: 1,
          properties: { Note: "Processing offset so the desk receives the gift in full" },
        });
      }
    }

    if (submit) submit.textContent = "Sending to checkout…";
    fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" })
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error("cart");
        window.location.href = "/checkout";
      })
      .catch(function () {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = "Shopify did not accept the cart. Confirm the products are published to the Online Store and inventory is not blocking the sale.";
        }
        paint();
      });
  });

  var posted = document.querySelector("[data-custom-request] .text-success");
  if (posted) amountInput.value = "custom";
  var params = new URLSearchParams(window.location.search);
  var deskParam = params.get("desk");
  if (deskParam && deskSelect) {
    deskSelect.value = deskParam;
    var countryRadio = form.querySelector('input[name="designation"][value="country"]');
    if (countryRadio) countryRadio.checked = true;
  }

  paint();
})();
